module.exports = __webpack_public_path__ + "img/currywurst-pommes.12bd3346.png";